import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnPinkSmall from '../../../Shared/Buttons/BtnPinkSmall';
import {setPackageCode, reportAnalytics} from './CellularPackageSlice';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import discountBg from './images/discount-bg.svg';

let svgImageForYou = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='102' height='102' viewBox='0 0 106 104'>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <path
                fill='#000000'
                d='M5.733.602l142.493.684L124.47 24.95c-1.503 1.497-3.533 2.345-5.655 2.36l-88.766.673c-.858.006-1.684-.328-2.296-.93L4.322 4.03c-.788-.774-.8-2.04-.025-2.828C4.675.815 5.193.6 5.733.602z'
                transform='translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778) rotate(180 74.518 14.286)'
              />
              <text
                fill='#FFF'
                fontSize='14'
                fontWeight='bold'
                transform='translate(-12 -254) translate(-9 233) rotate(-45 128.234 51.778)'>
                <tspan x='74' y='15' textAnchor='middle' dominantBaseline='central'>
                  {props.cornerBannerText.value}
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

let svgImageCircle = (props) => {
  return (
    <div className='special-offer'>
      <Image src={require('./images/stampa-1.svg')} alt='מחיר מיוחד באתר' />
      <div className='special-offer-text-holder'>
        <span className='special-offer-text'> {props.circleBannerText.value}</span>
      </div>
    </div>
  );
};

const setOfferBanner = (props) => {
  if (props.circleBannerText.value != '') {
    return (
      <div>
        <div className='special-offer'>{svgImageCircle(props)}</div>
      </div>
    );
  } else if (props.cornerBannerText.value != '') {
    return (
      <div>
        <div className='for-you-offer'>{svgImageForYou(props)}</div>
      </div>
    );
  } else {
    return null;
  }
};
const cellularPackage = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
    }
    if (props.saleType === 'cellular') {
      if (props.flowType === 'newCustomer') {
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: 'visibility_20',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
      } else {
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: 'visibility_9',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
      }
    }
  }, []);

  const gaEventAndOpen = () => {
    if (props.process) {
      switch (props.process) {
        case 'sale':
          break;
        case 'change_price_plan':
          if (!props.limited) {
            gaEvent(
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK.category,
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK.eventType,
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK.eventParams,
            );
          } else {
            gaEvent(
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK_FOR_LIMITED.category,
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK_FOR_LIMITED.eventType,
              gaParams.CHANGE_PRICE_PLAN_CLICK_OPEN_TERMS_CELLULAR_BLOCK_FOR_LIMITED.eventParams,
            );
          }
          break;
        default:
        // code block
      }
    }
    prepareUrl(props.data.productTermsLink.value, EpiContext);
  };

  const selectPackageHandler = (props) => {
    if (props.flowType === 'newCustomer') {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: 'click_42',
        eventLabel: props.productsInfo.selectedProducts[0]?.name,
      });
    } else {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: 'click_21',
        eventLabel: props.productsInfo.selectedProducts[0]?.name,
      });
    }
    props.setPackageCode({
      idDelivery: props.data.productIdDelivery?.value,
      idTechnitian: props.data.productMakat?.value,
    });
  };

  return (
    <Container className='cellularPackage'>
      <div className='cellularPackage-white-bg'>
        <div className='cellularPackage-container'>
          <Row className='content'>
            <Col className='content-holder'>
              <div className='offer-banner-holder'>
                <div className='package-name'>
                  <div className='package-name-title'>{props.data.productNameTitle.value}</div>
                  <div className='package-name-volume'>{props.data.packageVolumeTitle.value}</div>
                </div>
                {setOfferBanner(props.data)}
              </div>
              <div className='package-include-information'>
                {props.data.callsAndMessages.value == null || props.data.callsAndMessages.value == '' ? null : (
                  <div className='package-include'>
                    <div className='package-include-title'>{props.data.titleCallsAndMessages.value}</div>
                    <div className='package-include-details'>{props.data.callsAndMessages.value} </div>
                  </div>
                )}
                {props.data.callsAndMessages.value == null ||
                props.data.callsAndMessages.value == '' ||
                props.data.minutesForAbroadCalls.value == null ||
                props.data.minutesForAbroadCalls.value == '' ? null : (
                  <div className='separator'></div>
                )}
                {props.data.minutesForAbroadCalls.value == null || props.data.minutesForAbroadCalls.value == '' ? null : (
                  <div className='package-include'>
                    <div className='package-include-title'>{props.data.titleMinutesForAbroadCalls.value}</div>
                    <div className='package-include-details'>{props.data.minutesForAbroadCalls.value}</div>
                  </div>
                )}
              </div>
              <div className='purchase'>
                <div>
                  <div className='sale-price'>
                    <span>₪</span>
                    <span>{props.data.additionalPrice?.value}</span>
                  </div>
                  <div className='sale-price-month'>לחודש</div>
                </div>
                <div className='without-discount'>
                  {props.data.priceBeforeDiscount.value ? <div>₪{props.data.priceBeforeDiscount.value}</div> : null}
                </div>
                <div>
                  <div className='btn-pink-holder'>
                    <BtnPinkSmall
                      text='נשמע טוב'
                      onclick={() => {
                        props.orderEvent ? props.orderEvent(props.data) : selectPackageHandler(props);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className='footer-terms'>
        <div className='package-terms' onClick={() => gaEventAndOpen()}>
          <a>תנאי החבילה</a>
          <Image src={require('./images/arrow.svg')} alt='חץ' />
        </div>
        {props.changePP != undefined && props.changePP && (
          <div className='oneTimeFee'>
            <span className='pl-1'>{props.data.oneTimeFee.value}</span>
            ש״ח דמי מעבר חד פעמי
          </div>
        )}
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    cellularProductId: state.CellularPackage.cellularProductId,
    productsInfo: state.saleBlock.productsInfo,
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
  };
};

const mapDispatchToProps = {
  setPackageCode,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(cellularPackage);
